import Cookies from 'js-cookie';

export const setCookie = (key: string, value: string, options?: Record<string, unknown>): string | undefined =>
  Cookies.set(key, value, { domain: '.cian.ru', path: '/', ...options });

export const getCookie = (key: string): string | undefined => Cookies.get(key);
